import { Grid2 as Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import { ExternalLink } from "./ExternalLink";
import { formatAmount } from "../utils/formatAmount";
import { Info } from "@mui/icons-material";

type Props = {
  totalAmount: number;
  totalDueAmount: number;
  link?: string;
  currency?: string;
};

export function InvoiceTotalInfo({ totalAmount, totalDueAmount, link }: Props) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <Grid
      container
      alignItems="center"
      spacing={2}
      sx={{
        borderLeft: `6px solid ${theme.palette.primary.main}`,
        backgroundColor: isDarkMode ? "rgba(144, 202, 249, 0.12)" : "#ECF5FF",
        padding: "6px 10px 6px 6px",
      }}
    >
      <Info color="primary" />
      <Grid flex={1} textAlign="right">
        <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
          Owed: {totalAmount ? formatAmount(totalAmount) : "Nil balance"}
        </Typography>
        {totalDueAmount ? (
          <Typography sx={{ fontWeight: "bold", color: "red" }}>Overdue: {formatAmount(totalDueAmount)}</Typography>
        ) : null}
        {link && <ExternalLink href={link}>View Online</ExternalLink>}
      </Grid>
    </Grid>
  );
}
